import { Component } from 'react';
import { connect } from 'react-redux';
import { Alert, Button } from 'components/common';
import { DropdownButton } from 'components/common/dropdown';
import { Form } from 'components/common/form';
import {
  Modal,
  ModalContent,
  ModalFooter,
  ModalPortal
} from 'components/common/modal';

const ModalButtonWithForm = connect((state) => state)(
  class extends Component {
    state = {
      confirm: false,
      error: false,
      loading: false,
      modalVisible: this.props.forceModalVisible || false
    };

    componentDidMount() {
      this._ismounted = true;

      if (this.props.modalVisibleDefault) {
        this.showModal();
      }
    }

    componentDidUpdate(prevProps, prevState) {
      if (!prevState.modalVisible && this.state.modalVisible) {
        if (this.props.onModalVisible) this.props.onModalVisible();
      }

      if (!prevProps.showModal && this.props.showModal) {
        this.showModal();
      }
    }

    componentWillUnmount() {
      this._ismounted = false;
    }

    handleValueChange = (values) => {
      const { formOnValueChange, validateBeforeSubmit } = this.props;
      const { error } = this.state;

      if (
        error &&
        (!validateBeforeSubmit ||
          (validateBeforeSubmit && validateBeforeSubmit(values)))
      ) {
        this.setState({ error: false });
      }

      if (formOnValueChange) return formOnValueChange(values);
    };

    handleConfirm = () => {
      this.setState({ confirm: false });
      this.hideModal();
    };

    mockSubmit = () => {
      const currentValues = this.formApi.getValues();
      this.handleSubmit(currentValues);
    };

    handleSubmit = async (values) => {
      const { dispatch, onSubmit, validateBeforeSubmit } = this.props;

      try {
        this.setState({ loading: true });
        if (validateBeforeSubmit && !validateBeforeSubmit(values)) {
          this.setState({ error: true, loading: false });
          return;
        }

        const success = await onSubmit(values);
        if (!this._ismounted) return;

        this.setState({ loading: false });
        if (success !== false) this.hideModal(null, true);
      } catch (err) {
        this.setState({ loading: false });
        await dispatch.handleErrorDispatch(err);
      }
    };

    hideModal = (ev, afterSubmit = false) => {
      if (ev && this.props.stopPropagation) ev.stopPropagation();

      if (!afterSubmit && this.props.onKeepOpen && this.props.onKeepOpen()) {
        return;
      }

      this.setState({ modalVisible: false });
      this.formApi.reset();
      if (this.props.onHide) this.props.onHide();
      setTimeout(() => {
        if (this.buttonElement) this.buttonElement.focus();
      });
    };

    showModal = (ev) => {
      if (ev && this.props.stopPropagation) ev.stopPropagation();
      if (this.props.onShow) this.props.onShow();
      this.setState({ modalVisible: true });
    };

    handleContainerClick = () => {
      const { confirmChanges = true, initialValues, onKeepOpen } = this.props;
      if (onKeepOpen && onKeepOpen()) return;

      let isChanged = false;

      if (confirmChanges) {
        if (initialValues) {
          const currentValues = this.formApi.getValues();
          Object.entries(currentValues).forEach((entry) => {
            const current = JSON.stringify(entry[1]);
            const initial = JSON.stringify(initialValues[entry[0]]);

            if (initial !== current) {
              isChanged = true;
              this.setState({ confirm: true });
            }
          });
        } else {
          const { dirty } = this.formApi.getState();
          if (dirty) {
            isChanged = true;
            this.setState({ confirm: true });
          }
        }
      }

      if (!isChanged) this.hideModal();
    };

    setFormApi = (formApi) => {
      this.formApi = formApi;
      if (this.props.setFormApi) this.props.setFormApi(formApi);
    };

    setRef = (el) => {
      this.buttonElement = el;
      if (this.props.setRef) this.props.setRef(el);
    };

    render() {
      const {
        apiRef,
        buttonCategory,
        buttonDisabled,
        buttonIcon,
        buttonIsDropdown,
        buttonProps,
        buttonSize,
        buttonStyle,
        buttonText,
        buttonTextHideBreakpoint,
        children,
        contentStyle,
        footerCancelButtonText,
        footerCloseButton,
        footerContent,
        footerStyle,
        forceModalVisible,
        formAllowEmptyStrings,
        initialValues = {},
        messages,
        modalActionCategory,
        modalActionText,
        modalActionTooltip,
        modalAutoFocus,
        modalCloseButton,
        modalHideCancel,
        modalStyle,
        modalTitle,
        modalWidth,
        pristineIsValid = true,
        stopPropagation,
        submitDisabled,
        preventSubmit
      } = this.props;

      const { confirm, error, loading, modalVisible } = this.state;

      return (
        <>
          {buttonIsDropdown ? (
            <DropdownButton
              disabled={buttonDisabled}
              icon={buttonIcon}
              onClick={this.showModal}
              ref={this.setRef}
              style={buttonStyle}
              text={buttonText}
              {...buttonProps}
            />
          ) : !forceModalVisible ? (
            <Button
              category={buttonCategory}
              disabled={buttonDisabled}
              icon={buttonIcon}
              onClick={this.showModal}
              ref={this.setRef}
              size={buttonSize}
              style={buttonStyle}
              text={buttonText}
              textHideBreakpoint={buttonTextHideBreakpoint}
              {...buttonProps}
            />
          ) : null}
          <ModalPortal>
            <Form
              allowEmptyStrings={formAllowEmptyStrings}
              apiRef={apiRef}
              getApi={this.setFormApi}
              initialValues={initialValues}
              onSubmit={this.handleSubmit}
              onValueChange={this.handleValueChange}
            >
              {({ formState }) => {
                const isSubmitDisabled =
                  formState.invalid ||
                  (formState.pristine && !pristineIsValid) ||
                  error ||
                  submitDisabled;

                return (
                  <Modal
                    autoFocus={modalAutoFocus}
                    onContainerClick={this.handleContainerClick}
                    onHide={this.hideModal}
                    stopPropagation={stopPropagation}
                    style={modalStyle}
                    title={modalTitle}
                    visible={modalVisible}
                    width={modalWidth}
                  >
                    <ModalContent style={contentStyle}>
                      {modalVisible && !loading && confirm ? (
                        <ModalPortal>
                          <Modal
                            onHide={() => this.setState({ confirm: false })}
                            stopPropagation={true}
                            title={messages.activitiesChangesDetected}
                            visible={confirm}
                            width="small"
                          >
                            <ModalContent>
                              {messages.activitiesChangesDetectedInfo}
                            </ModalContent>

                            <ModalFooter>
                              {modalHideCancel ? null : (
                                <Button
                                  category="light"
                                  onClick={() =>
                                    this.setState({ confirm: false })
                                  }
                                  text={messages.commonCancel}
                                />
                              )}
                              <Button
                                autoFocus={true}
                                category="default"
                                onClick={this.handleConfirm}
                                text={messages.commonConfirm}
                              />
                            </ModalFooter>
                          </Modal>
                        </ModalPortal>
                      ) : null}

                      {children(formState)}
                    </ModalContent>

                    <ModalFooter style={footerStyle}>
                      {footerContent ? footerContent : null}

                      {footerCloseButton ? (
                        <Button
                          category="light"
                          onClick={this.hideModal}
                          text={messages.commonClose}
                        />
                      ) : (
                        <>
                          {modalHideCancel ? null : (
                            <Button
                              category="light"
                              onClick={this.hideModal}
                              text={
                                footerCancelButtonText ||
                                (modalCloseButton
                                  ? messages.commonClose
                                  : messages.commonCancel)
                              }
                            />
                          )}

                          {preventSubmit ? (
                            <Button
                              category={modalActionCategory || buttonCategory}
                              disabled={isSubmitDisabled}
                              loading={loading}
                              onClick={this.mockSubmit}
                              text={modalActionText}
                              tooltip={modalActionTooltip}
                            />
                          ) : (
                            <Button
                              category={modalActionCategory || buttonCategory}
                              disabled={isSubmitDisabled}
                              loading={loading}
                              text={modalActionText}
                              tooltip={modalActionTooltip}
                              type="submit"
                            />
                          )}
                        </>
                      )}
                    </ModalFooter>
                  </Modal>
                );
              }}
            </Form>
          </ModalPortal>
        </>
      );
    }
  }
);

export default ModalButtonWithForm;
